import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IClientPortalUsersService } from "services/ClientPortalUsersService";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { RootState } from "setup/redux/RootReducer";

type ResetPasswordState = {
  PasswordReset: boolean;
  UpdatingPassword: boolean;
};

const initialState: ResetPasswordState = {
  PasswordReset: false,
  UpdatingPassword: false,
};

export const resetPasswordSlice = createSlice({
  name: "ResetPassword",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(changeClientPortalUserPassword.pending, (state) => {
        state.UpdatingPassword = true;
      })
      .addCase(changeClientPortalUserPassword.rejected, (state) => {
        state.PasswordReset = false;
        state.UpdatingPassword = false;
      })
      .addCase(changeClientPortalUserPassword.fulfilled, (state) => {
        state.PasswordReset = true;
        state.UpdatingPassword = false;
      });
  },
});

export const changeClientPortalUserPassword = createAsyncThunk(
  "ResetPassword/ChangeClientPortalUserPassword",
  async (newPassword: string) => {
    const usersService = container.get<IClientPortalUsersService>(SERVICE_TYPES.ClientPortalUsersService);
    await usersService.changeClientPortalUserPassword(newPassword);
  }
);

export const selectUpdatingPassword = (state: RootState) => state.resetPassword.UpdatingPassword;
export const selectPasswordReset = (state: RootState) => state.resetPassword.PasswordReset;

export default resetPasswordSlice.reducer;
